module.exports = __webpack_public_path__ + "static/jared_testimonial-f0358b68675a4693766363524b2720a6.jpg";